import { makeAutoObservable } from "mobx";
import ApiStore from "./ApiStore";
import dayjs, { Dayjs } from 'dayjs';
import { CalendarEvent } from "../api/EventsApiClient";
import { Employee } from "../models/Employee";

class EventStore {
  isLoading: boolean = true;
  ApiStore!: ApiStore;
  events: CalendarEvent[];
  birthdays: CalendarEvent[];
  constructor(apiStore: ApiStore) {
    makeAutoObservable(this);
    this.ApiStore = apiStore;
    this.events = [];
    this.birthdays = [];
  }

  setLoading = (loading: boolean) => {
    this.isLoading = loading;
  }

  add = async (event: any) => {
    this.isLoading = true;
    const response = await this.ApiStore.EventsApiClient.addEvent(event);
    this.isLoading = false;
    return response;
  }

  getAll = async () => {
    this.isLoading = true;
    const result = await this.ApiStore.EventsApiClient.getAll().then(res => {
      this.events = res.filter(event => event.type !== "Birthday");
      return res.filter(event => event.type !== "Birthday");
    }).finally(() => {
      this.isLoading = false;
    });
    return result;
  }

  getBirthdays = async (users: Employee[]) => {
    this.isLoading = true;
    const birtdays = users.filter(user => user.birthDay).map((user, index) => {
      const birthday: CalendarEvent = {
        id: `brt${index}`,
        startDate: dayjs(user.birthDay),
        endDate: dayjs(user.birthDay),
        type: "Birthday",
        userId: user.id
      }
      return birthday;
    });
    this.birthdays = birtdays;
    this.isLoading = false;

    return birtdays;
  }

  deleteById = async (id: string) => {
    this.isLoading = true;
    const project = await this.ApiStore.EventsApiClient.deleteEvent(id).then(() => {
      this.events = this.events.filter(el => el.id !== id)
    }).finally(() => {
      this.isLoading = false;
    });
    return project;
  }

  checkRegularEventForDaysConflict = (userId: string, newStart: Dayjs, newEnd: Dayjs, eventType?: string): boolean => {
    const regularEventTypes = ['Leave', 'SickLeave', 'TimeOff'];

    return this.events.some(event => {
      if (event.userId !== userId) return false;

      if (!regularEventTypes.includes(event.type)) return false;

      const existingStart = dayjs(event.startDate);
      const existingEnd = dayjs(event.endDate);

      return (
        newStart.isSameOrBefore(existingEnd, 'day') &&
        newEnd.isSameOrAfter(existingStart, 'day')
      );
    });
  }
}
export default EventStore;
